<template>
  <div v-if="dataPermission.includes('CNPS_CALENDAR_WK_GROUP_LIST')">
    <div class="breadcrumb-area pos-relative w-100">
      <h1>Nhóm công việc</h1>
      <div class="float-right btn-group">
        <DraggableTable
          :naming="$route.name"
          v-model="fieldsTable"
          @change="filterTable = $event"
        />
        <button
          @click="$router.push('/group-calendar-afs-add')"
          v-if="dataPermission.includes('CNPS_CALENDAR_WK_GROUP_INSERT')"
          class="font-medium f12 btn btn-outline-secondary"
        >
          <i class="bx bx-plus-circle"></i> Thêm mới
        </button>
        <button
          @click="$router.push('/group-calendar-afs-import')"
          class="font-medium f12 btn btn-outline-secondary"
        >
          <i class="bx bx-upload"></i> Nhập excel
        </button>
        <button
          @click="exportExcel"
          v-if="dataPermission.includes('CNPS_CALENDAR_WK_GROUP_XLS')"
          class="font-medium f12 btn btn-outline-secondary"
        >
          <i class="bx bx-download"></i> Xuất excel
        </button>
      </div>
    </div>
    <VueLoadingOverlay :active.sync="showLoading" :is-full-page="true"> </VueLoadingOverlay>
    <div class="p-10 card pt-15 b-t-1-869fb229">
      <div class="card-header m-b-10">
        <form class="box-search" @submit="submitForm">
          <div class="form-group">
            <DateRangePicker
              class="w-100"
              :ranges="false"
              @update="transfromDate()"
              v-model="dateRange"
              :locale-data="localeData"
            >
              <template v-slot:input="picker">
                <label
                  v-if="picker.startDate && picker.endDate"
                  style="min-width: 13.5em"
                  class="text-center font-size-12"
                >
                  {{ picker.startDate | formatDate }} - {{ picker.endDate | formatDate }}
                </label>
                <label v-else style="min-width: 13.5em" class="font-size-12 time-placeholder">
                  Thời gian tạo
                </label>
              </template>
            </DateRangePicker>
          </div>
          <div class="form-group">
            <Select2 v-model="search.service" :options="optionService" placeholder="Dịch vụ">
            </Select2>
          </div>
          <div class="form-group">
            <input
              type="text"
              v-model.trim="search.groupName"
              class="form-control f12 hc-37"
              placeholder="Tên nhóm"
            />
          </div>
          <div class="form-group">
            <Select2 v-model="search.status" :options="optionStatus" placeholder="Trạng thái">
            </Select2>
          </div>
          <div class="form-group form-group-action">
            <button
              @click="submitForm"
              class="pt-2 mr-2 btn btn-primary hc-37"
              type="button"
              data-toggle="tooltip"
              data-placement="top"
              title="Lọc"
            >
              <i class="bx bx-filter-alt"></i>
              <span class="ml-1"></span>Lọc
            </button>
            <button
              @click="removeForm"
              class="pt-2 mr-2 btn btn-outline-light hc-37"
              type="button"
              data-toggle="tooltip"
              data-placement="top"
              title="Bỏ lọc"
            >
              <i class="bx bx-filter-alt"></i>
              <span class="ml-1"></span>Bỏ lọc
            </button>
          </div>
        </form>
      </div>
      <div class="card-body">
        <div class="tab-content" id="nav-tabContent">
          <div class="p-10">
            <span><b>Tổng nhóm công việc</b>: {{ pagination.total }}</span>
            <b-table
              :busy.sync="loading"
              sticky-header
              hover
              responsive
              :items="dataGroup"
              :fields="filterTable"
              :fixed="true"
              :bordered="true"
            >
              <template #table-busy>
                <div class="my-2 text-center">
                  <b-spinner class="align-middle"></b-spinner>
                </div>
              </template>
              <template #cell(index)="data">
                {{ getIndex(data.index) }}
              </template>
              <template #cell(createdDate)="data">
                {{ data.item.createdDate | formatDate }}
              </template>
              <template #cell(status)="data">
                <b-badge
                  class="font-size-12"
                  pill
                  :variant="data.item.status == 'APPLYING' ? 'primary' : 'danger'"
                  size="sm"
                >
                  {{ data.item.status | mapStatus(optionStatus) }}
                </b-badge>
              </template>
              <template #cell(action)="data">
                <b-dropdown id="dropdown-1" class="m-md-2" variant="outline-light">
                  <b-dropdown-item @click="detailGrW(data.item)">Chi tiết</b-dropdown-item>
                  <b-dropdown-item
                    @click="$router.push({ path: `/group-calendar-afs/edit/${data.item.id}` })"
                    v-if="
                      data.item.status == 'APPLYING' &&
                      dataPermission.includes('CNPS_CALENDAR_WK_GROUP_UPDATE')
                    "
                    >Sửa</b-dropdown-item
                  >
                  <b-dropdown-item
                    @click="LocknUnlockGrW(data.item)"
                    v-if="data.item.status == 'APPLYING'"
                    >Khoá</b-dropdown-item
                  >
                  <b-dropdown-item @click="LocknUnlockGrW(data.item)" v-else
                    >Mở khoá</b-dropdown-item
                  >
                </b-dropdown>
              </template>
            </b-table>
          </div>
        </div>
      </div>
      <div class="pagination-bottom">
        <b-pagination
          class="mr-2 fl-right"
          v-model="search.page"
          :total-rows="pagination.total"
          :per-page="search.size"
        ></b-pagination>
      </div>
    </div>
    <!-- Modal xác nhận mở khoá/ khoá-->
    <b-modal id="modal-scoped" v-model="lockModal">
      <template #modal-header="{ close }">
        <h5 v-if="stateGr.status == 'APPLYING'">Khoá nhóm công việc</h5>
        <h5 v-else>Mở khoá nhóm công việc</h5>
        <b-button size="sm" variant="light" @click="close()"> x </b-button>
      </template>
      <div class="text-center">
        <h2 class="py-3 f18" v-if="stateGr.status == 'APPLYING'">
          Bạn muốn khoá nhóm công việc này ?
        </h2>
        <h2 class="py-3 f18" v-else>Bạn muốn mở khoá nhóm công việc này ?</h2>
      </div>
      <template #modal-footer="{ cancel }">
        <b-button variant="light" @click="cancel()"> Đóng </b-button>
        <b-button variant="primary" @click="cancel(), confirmLocknActive()"> Xác nhận </b-button>
      </template>
    </b-modal>
    <!-- Modal thông báo -->
    <b-modal id="modal-scoped" v-model="notiModal">
      <template #modal-header="{ close }">
        <h5>Thông báo</h5>
        <b-button variant="light" @click="close()"> x </b-button>
      </template>
      <div class="text-center">
        <img :src="iconNoti" :alt="iconNoti" />
        <h2 class="py-3 f18">{{ msgNoti }}</h2>
      </div>
      <template #modal-footer="{ cancel }">
        <b-button variant="light" @click="cancel()"> Đóng </b-button>
      </template>
    </b-modal>
  </div>
</template>
<script>
  import { CalendarAfsService } from '@/services/calendar-afs.service'
  import prepareQueryParamsMixin from '../../../mixins/prepareQueryParamsMixin'
  import Config from '@/thirdParty/config'
  import moment from 'moment'
  import DateRangePicker from 'vue2-daterange-picker'
  import 'vue2-daterange-picker/dist/vue2-daterange-picker.css'
  import { SalesManagerService } from '@/services/sales-manager.service'
  import { mapGetters } from 'vuex'
  const fieldsTable = [
    { key: 'index', label: 'STT', class: 'text-center' },
    { key: 'createdDate', label: 'Thời gian tạo' },
    { key: 'groupCode', label: 'Mã nhóm' },
    { key: 'groupName', label: 'Tên nhóm' },
    { key: 'service', label: 'Dịch vụ' },
    { key: 'note', label: 'Mô tả' },
    { key: 'finishTime', label: 'Thời gian hoàn thành' },
    { key: 'status', label: 'Trạng thái' },
    { key: 'action', label: 'Thao tác', fixIndex: 999, class: 'text-center' },
  ]
  export default {
    data() {
      return {
        loading: false,
        showLoading: false,
        notiModal: false,
        iconNoti: '',
        msgNoti: '',
        dataGroup: [],
        search: {
          page: 1,
          size: 20,
        },
        pagination: {
          total: 0,
        },
        fieldsTable,
        filterTable: fieldsTable,
        dateRange: {
          startDate: null,
          endDate: null,
        },
        localeData: Config.localeData,
        optionStatus: Config.statusCalendar,
        optionService: [],
        lockModal: false,
        stateGr: {},
        draggableTest: false,
      }
    },
    mixins: [prepareQueryParamsMixin],
    created() {
      this.fetchData()
      this.getListService()
    },
    components: {
      DateRangePicker,
    },
    computed: {
      useInUrlQueryPropList() {
        return this.prepareQueryParamsMixin({
          size: this.search.size,
          page: this.search.page,
        })
      },
      ...mapGetters({
        dataPermission: 'role/dataPermission',
      }),
    },
    watch: {
      'search.page': function () {
        this.$router.replace({
          query: this.useInUrlQueryPropList,
        })
        this.fetchData()
      },
    },
    methods: {
      // xuất excel
      async exportExcel() {
        try {
          this.showLoading = true
          await CalendarAfsService.exportGroupCalendar(this.search)
        } catch (error) {
          console.log(error)
        } finally {
          this.showLoading = false
        }
      },
      // list dịch vụ - sản phẩm
      async getListService() {
        try {
          const data = await SalesManagerService.getGroupService({})
          if (data.success) {
            this.optionService = data.data.groupService
              .map(e => e.detail)
              .flat()
              .map(el => {
                return {
                  id: el.code,
                  text: el.name,
                }
              })
            this.optionService.unshift({ id: 0, text: 'Tất cả' })
          }
        } catch (error) {
          console.log(error)
        }
      },
      // chuyển dạng ngày, tháng
      transfromDate() {
        this.search.fromDate = moment(this.dateRange.startDate).startOf('day').valueOf()
        this.search.toDate = moment(this.dateRange.endDate).endOf('day').valueOf()
      },
      // Lọc
      async submitForm(event) {
        event.preventDefault()
        this.pagination.page = 1
        this.fetchData()
      },
      // Bỏ lọc
      async removeForm() {
        this.search = {
          size: 20,
          page: 1,
        }
        this.dateRange = {
          startDate: null,
          endDate: null,
        }
        await this.fetchData()
      },
      // dữ liệu bảng
      async fetchData() {
        try {
          this.loading = true
          if (this.search.service === '0') delete this.search.service
          if (this.search.status === '0') delete this.search.status
          const data = await CalendarAfsService.groupCalendar(this.search)
          if (data.success) {
            this.pagination.total = data.totalPage?.total ?? 0
            this.dataGroup = data.data
          }
          if (data.code === 1004) {
            this.dataGroup = []
            this.pagination.total = 0
          }
        } catch (error) {
          console.log(error)
        } finally {
          this.loading = false
        }
      },
      // chi tiết
      detailGrW(item) {
        window.open(`/group-calendar-afs/${item.id}`, '_blank')
      },
      LocknUnlockGrW(item) {
        this.stateGr = item
        this.lockModal = true
      },
      async confirmLocknActive() {
        try {
          if (this.stateGr.status === 'APPLYING') {
            const data = await CalendarAfsService.lockGroupCalendar({ id: this.stateGr.id })
            if (data.success) {
              this.notiModal = true
              this.iconNoti = require('@/assets/img/noti-success2.svg')
              this.msgNoti = 'Khoá thành công'
            }
          } else {
            const data = await CalendarAfsService.unlockGroupCalendar({ id: this.stateGr.id })
            if (data.success) {
              this.notiModal = true
              this.iconNoti = require('@/assets/img/noti-success2.svg')
              this.msgNoti = 'Mở khoá thành công'
            }
          }
          await this.fetchData()
        } catch (error) {
          console.log(error)
        }
      },
    },
  }
</script>
